<template>
  <div id="zoomPhotos" v-show="active">
    <div class="container">
      <div class="row">
        <div class="col-sm-1"></div>
        <div class="col-sm-10">
          <div id="carouselExampleControls" class="carousel slide touch-zoom" data-bs-ride="carousel">
            <header class="zoom-header">
              <div class="zoom-header-content">
                <!-- Acciones principales -->
                <div class="actions-container">
                  <ul class="actions-list">
                    <!-- Descarga -->
                    <li v-if="currentPhoto.free()">
                      <button class="action-btn" :title="$t('photo.download')" @click="download">
                        <i class="fa fa-arrow-down"></i>
                      </button>
                    </li>

                    <!-- Compartir -->
                    <li v-if="currentPhoto.free() && socialShare">
                      <button class="action-btn" :title="$t('photo.share')" @click="share">
                        <i class="fa fa-share-alt"></i>
                      </button>
                    </li>

                    <!-- Carrito -->
                    <li v-if="!currentPhoto.free()">
                      <button class="action-btn" :title="$t('photo.addToCart')" @click="addToCart">
                        <i class="fa fa-shopping-cart"></i>
                      </button>
                    </li>

                    <!-- Rekognition -->
                    <li v-if="currentPhoto.search_face">
                      <button class="action-btn" :title="$t('photo.rekognition')" @click="rekognition">
                        <img src="../images/rekognition_white.png" alt="rekognition">
                      </button>
                    </li>

                    <!-- Favoritos -->
                    <li>
                      <button
                          class="action-btn"
                          :title="currentPhoto.selected ? $t('photo.removeFromFavorites') : $t('photo.addToFavorites')"
                          @click="currentPhoto.selected ? remove() : add()">
                        <i :class="['fa', currentPhoto.selected ? 'fa-heart' : 'fa-heart-o']"></i>
                      </button>
                    </li>
                  </ul>

                  <!-- Acciones de Álbum -->
                  <div v-if="(!event.active_pre_order && (event.sale || event.generate_album))"
                       class="album-actions">
                    <template v-if="!album.canSend()">
                      <button v-if="onlyDownload || onlyCategoriesDownload"
                              class="album-btn"
                              @click="downloadAlbum()"
                              :title="$t('events.show.downloadAlbum')">
                        {{ $t("events.show.downloadAlbum") }}
                      </button>
                      <button v-else
                              class="album-btn"
                              @click="addGalleryToCart()"
                              :title="event.price_album | toCurrency">
                        {{ $t("events.show.buyAlbum") }}
                      </button>
                      <i class="fa fa-info-circle info-icon" :title="event.album_concept"/>
                    </template>

                    <button v-else
                            class="album-btn"
                            @click="openConfirmSendAlbum()">
                      {{ $t("albums.send") }}
                    </button>
                  </div>
                </div>

                <!-- Botón cerrar -->
                <button class="close-btn" @click="close">
                  <i class="fa fa-times"></i>
                </button>
              </div>

              <SocialMedia
                  :activeShareMedia="activeShare"
                  :photo="currentPhoto"
                  full="true"
                  class="social-media-component"/>
            </header>

            <div id="zoom-photos" class="carousel-inner">
              <div class="carousel-item"
                   v-for="(photo, index) in photos"
                   :key="index"
                   v-bind:class="{active: index == activeIndex}">
                <img :src="photo.zoom" class="d-block"/>
              </div>
            </div>
            <div class="thumbnail-gallery">
              <button @click="prevThumbnails" :disabled="thumbnailPage === 0">
                <i class="fa fa-chevron-left color-white-icons next-arrows-right"></i>
              </button>

              <div class="thumbnails">
                <div class="thumbnail-container">
                  <div
                      v-for="(photo, index) in paginatedThumbnails"
                      :key="index"
                      class="thumbnail"
                      @click="setPhoto(index + thumbnailPage * thumbnailsPerPage)"

                  >
                    <img
                        :style="{ border: (index + thumbnailPage * thumbnailsPerPage) === currentIndex ? '6px solid #00e7ff' : '' }"
                        :src="photo.thumb" alt="Thumbnail"/>
                  </div>
                </div>
              </div>

              <button @click="nextThumbnails" :disabled="thumbnailPage >= maxThumbnailPages - 1">
                <i class="fa fa-chevron-right color-white-icons next-arrows-left"></i>
              </button>
            </div>
            <div class="total-zoom color-white-icons">
              {{ totalLegend }}
            </div>
            <button class="nav-button carousel-control-prev" type="button" data-bs-target="#carouselExampleControls"
                    data-bs-slide="prev" ref="prev">
              <i class="fa fa-chevron-left nav-icon"></i>
            </button>
            <button class="nav-button carousel-control-next" type="button" data-bs-target="#carouselExampleControls"
                    data-bs-slide="next" ref="next">
              <i class="fa fa-chevron-right nav-icon"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex';
import Photo from '../models/Photo';
import SocialMedia from "./SocialMedia";
import DownloadMixin from '../mixins/DownloadMixin';
import Album from "../models/Album";
import PageContent from "../models/PageContent";

export default {
  name: "PhotoZoom",
  mixins: [
    DownloadMixin
  ],
  components: {
    SocialMedia
  },
  props: {
    zoomPhotos: [],
    photo: {},
    event: {
      type: Object,
      default: null
    },
    competitor: {
      type: Object,
      default: null
    },
    categories: {
      type: Array,
      default: null
    },
    activeIndex: {
      type: Number,
      default: 0
    },
    albumId: {
      type: Number | String,
      default: null
    },
    active: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      currentPhoto: new Photo(),
      activeShare: false,
      carousel: {},
      photos: [],
      currentIndex: 0,
      thumbnailPage: 0,
      thumbnailsPerPage: 10,
      thumbnailOffset: 0,
      thumbnailWidth: 100,
      showAlbums: false,
      isCarouselTransitioning: false,
      activeAlbum: false,
      album: new Album(),
    }
  },
  mounted() {
    const _this = this,
        carousel = document.getElementById('carouselExampleControls')

    this.carousel = new bootstrap.Carousel(carousel, {
      interval: false,
      wrap: true,
      pause: true
    });

    carousel.addEventListener('slide.bs.carousel', function (slide) {
      if (_this.currentIndex !== slide.to) {
        _this.setPhoto(slide.to);
      }
    });

    document.addEventListener('keydown', function (e) {
      switch (e.keyCode) {
        case 37:
          _this.$refs.prev.click()
          break;
        case 39:
          _this.$refs.next.click()
          break;
      }
    })
  },
  watch: {
    active(value) {
      if (value) {
        this.currentIndex = this.activeIndex;
        // Inicializamos currentPhoto cuando se activa el zoom
        if (this.photos.length > 0) {
          this.currentPhoto = this.photos[this.currentIndex];
        }
      }
    },
    zoomPhotos(photos) {
      this.photos = photos.map(photo => new Photo(photo));

      if (photos.length == 0) {
        this.currentIndex = 0;
      } else {
        this.setPhoto(this.activeIndex);
      }

      // También inicializamos currentPhoto cuando se cargan las fotos
      if (photos.length > 0) {
        this.currentPhoto = this.photos[this.currentIndex];
      }
    }
  },
  methods: {
    ...mapActions('ShoppingCartStore', ['addShoppingCartItem']),
    async openConfirmSendAlbum() {
      this.loading = true;
      const pageContent = new PageContent();
      const content = await pageContent.show("confirm_send_album");

      this.confirmationContent = new PageContent(content).htmlContent();
      this.displayConfirmAlbum = true;
      this.loading = false;
    },
    async addGalleryToCart() {
      const params = {event_id: this.event.identifier, photo_id: null, album_id: this.albumId};
      this.$alertify.success(this.$t("checkout.addedItem"))
      await this.addShoppingCartItem(params);
      this.$root.$emit("addItemToCart", params)
    },
    async downloadAlbum() {
      try {
        this.loading = true
        const response = await this.$http.get(`/api/v3/albums/${this.albumId}/download`);

        if (response.status == 200 || response.status == 304) {
          location.href = response.data.url
        }
      } catch (e) {
        this.$alertify.error("Error")
      } finally {
        this.loading = false
      }
    },
    async addToCart() {
      const params = {event_id: this.currentPhoto.event_id, photo_id: this.currentPhoto.id};
      this.$alertify.success(this.$t("checkout.addedItem"))
      await this.addShoppingCartItem(params);
      this.$root.$emit("addItemToCart", params);
    },
    async download() {
      if (this.requireSignIn) {
        this.close();
        this.openSignin();
      } else {
        await this.downloadPhoto(this.currentPhoto);
      }
    },
    close() {
      this.activeShare = false;
      this.$emit("closeZoom", false)
    },
    setPhoto(index) {
      if (this.currentIndex === index) {
        return;
      }

      this.currentIndex = index;
      this.currentPhoto = this.photos[index];

      if (!this.isCarouselTransitioning) {
        this.isCarouselTransitioning = true;
        this.carousel.to(index);
        this.isCarouselTransitioning = false;
      }

      const newThumbnailPage = Math.floor(index / this.thumbnailsPerPage);
      if (this.thumbnailPage !== newThumbnailPage) {
        this.thumbnailPage = newThumbnailPage;
        this.thumbnailOffset = -(this.thumbnailPage * this.thumbnailsPerPage * this.thumbnailWidth);
      }
    },
    nextThumbnails() {
      if (this.thumbnailPage < this.maxThumbnailPages - 1) {
        this.thumbnailPage++;
        this.thumbnailOffset = -(this.thumbnailPage * this.thumbnailsPerPage * this.thumbnailWidth);
      }
    },
    prevThumbnails() {
      if (this.thumbnailPage > 0) {
        this.thumbnailPage--;
        this.thumbnailOffset = -(this.thumbnailPage * this.thumbnailsPerPage * this.thumbnailWidth);
      }
    },
    add() {
      this.currentPhoto.addFavorite(this.parameters).then(() => {
        this.$root.$emit('addFavoritePhoto', this.currentPhoto)
      }).catch((error) => {
        this.selected = false
      })
    },
    remove() {
      this.$root.$emit('removeFavoritePhoto', this.currentPhoto)
      this.currentPhoto.removeFavorite(this.parameters).then(() => {
      })
          .catch((error) => {
            console.log(error)
          })
    },
    share() {
      if (this.requireSignIn) {
        this.close();
        this.openSignin();
      } else {
        this.activeShare = !this.activeShare;
      }
    },
    rekognition() {
      let competitor = null
      this.$emit("setLoader", true)

      if (this.competitor && this.competitor.number) {
        competitor = this.competitor.number
      }

      this.currentPhoto.rekognition({competitor: competitor}).then((object) => {
        this.$root.$emit('addRekognitionPhotos', object.response.data.photos)
        this.close()
        this.$emit("setLoader", false)
      }).catch((error) => {
        console.log(error)
        this.$emit("setLoader", false)
      })
    }
  },
  computed: {
    ...mapGetters('Auth', ['currentUser']),
    displayAlbums() {
      return this.event.generate_album;
    },
    canAddToAlbum() {
      return this.event.generate_album;
    },
    onlyDownload() {
      if (this.album.photos.length > 0) {
        return this.album.photos.every((photo) => photo.sponsored);
      }
      return false;
    },
    onlyCategoriesDownload() {
      if (this.categories.length > 0) {
        return this.categories.every((category) => category.sponsored);
      }
      return false;
    },
    paginatedThumbnails() {
      // Retorna las miniaturas que se mostrarán en la página actual
      const start = this.thumbnailPage * this.thumbnailsPerPage;
      const end = start + this.thumbnailsPerPage;
      return this.photos.slice(start, end);
    },
    maxThumbnailPages() {
      return Math.ceil(this.photos.length / this.thumbnailsPerPage);
    },
    parameters() {
      return {
        competitor: this.competitorId
      };
    },
    competitorId() {
      return (this.competitor == null) ? null : this.competitor.number;
    },
    total() {
      return this.photos.length
    },
    numberPhoto() {
      return this.currentIndex + 1
    },
    totalLegend() {
      return `${this.numberPhoto} / ${this.total}`
    },
    free() {
      return this.currentPhoto.free()
    },
    socialShare() {
      return this.event.share_social_media;
    },
  }
}
</script>

<style lang="scss" scoped>
$color: gray;
.zoom-header {
  position: relative;
  padding: 1rem;
  margin-top: 40px;

  .zoom-header-content {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 1rem;
  }

  .actions-container {
    display: flex;
    align-items: center;
    gap: 2rem;
  }

  .actions-list {
    display: flex;
    align-items: center;
    gap: 1rem;
    list-style: none;
    padding: 0;
    margin: 0;

    li {
      margin: 0;
    }
  }

  .action-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: transparent;
    border: none;
    cursor: pointer;
    transition: all 0.2s ease;
    color: white;

    &:hover {
      background: rgba(255, 255, 255, 0.1);
    }

    i {
      font-size: 1.50rem;
    }

    img {
      width: 24px;
      height: 24px;
      object-fit: contain;
    }
  }

  .album-actions {
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }

  .album-btn {
    padding: 0.5rem 1rem;
    border-radius: 4px;
    background: transparent;
    border: 2px solid white;
    color: white;
    cursor: pointer;
    transition: all 0.2s ease;
    font-size: 0.875rem;

    &:hover {
      background: rgba(255, 255, 255, 0.1);
    }
  }

  .info-icon {
    color: white;
    font-size: 1.125rem;
    cursor: help;
  }

  .close-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: transparent;
    border: none;
    cursor: pointer;
    transition: all 0.2s ease;
    color: white;

    &:hover {
      background: rgba(255, 255, 255, 0.1);
    }

    i {
      font-size: 1.50rem;
    }
  }

  .social-media-component {
    top: 100px !important;
  }
}

@media (max-width: 768px) {
  .zoom-header {
    .actions-container {
      flex-direction: column;
      align-items: flex-start;
      gap: 1rem;
    }

    .album-actions {
      width: 100%;
      justify-content: center;

      .album-btn {
        flex: 1;
        text-align: center;
      }
    }
  }
}

#zoomPhotos {
  display: block;
  position: fixed;
  top: 0;
  bottom: 0;
  width: 100%;
  background-color: rgba(24, 23, 28, 0.9);
  z-index: 50;
  margin-top: 50px;
  overflow-x: hidden;
  overflow-y: auto;
  inset: 0px;
  outline: 2px solid transparent;
  outline-offset: 2px;
}

#zoom-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 12vh;
  position: relative;

  ul {
    position: absolute;
    bottom: 0;
    padding: 0;

    li {
      padding-right: 2rem;
      display: inline;

      a {
        color: $color;
        font-size: 24px;
        cursor: pointer;

        img {
          width: 24px !important;
          height: 24px !important;
          vertical-align: text-top;
          margin-top: 1px;
        }
      }
    }
  }
}

#zoom-photos {
  height: 67vh !important;
  margin-bottom: 17px;

  .carousel-item {
    height: 100%;
  }

  img {
    margin: auto;
    height: 100%;
    max-width: 100%;
    object-fit: contain;
  }

  .active {
    display: flex !important;
  }


}


.total-zoom {
  text-align: center;
  line-height: 50px;
  color: $color;
  font-size: 18px;
}

.close-zoom {
  margin-top: 40px !important;
  cursor: pointer;
  font-size: 21px;
  color: $color;
  width: 32px;
  height: 32px;
  z-index: 9999;
}


@media screen and (max-width: 600px) {
  #zoom-photos {
    height: 40vh !important;

  }
  .carousel-control-next, .carousel-control-prev {
    top: 30%;
    bottom: 30%;
  }
}


.carousel-inner {
  touch-action: pan-y !important;
}


.carousel-control-prev,
.carousel-control-next {
  pointer-events: none;
}

.carousel-control-prev i,
.carousel-control-next i {
  pointer-events: all;
}

#zoom-photos {
  touch-action: manipulation;
  height: auto;
}

.carousel-inner {
  touch-action: pinch-zoom !important;
}

.touch-zoom {
  touch-action: pinch-zoom !important;
}


.thumbnail-gallery {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 5px !important;

  .thumbnails {
    overflow: hidden;
    width: 80%; /* Ajusta esto según el diseño */
    position: relative;

    .thumbnail-container {
      display: flex;
      transition: transform 0.3s ease; /* Animación suave para el desplazamiento */
    }

    .thumbnail {
      margin: 0 5px;
      cursor: pointer;

      img {
        width: 80px;
        height: 80px;
        object-fit: cover;
      }
    }
  }
}



.color-white-icons {
  color: white;
}

.next-arrows-left {
  margin-left: 11px;
  font-size: 23px;
}

.next-arrows-right {
  margin-right: 11px;
  font-size: 23px;
}

.vh--message {
  display: none !important;
}

.nav-button {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(255, 255, 255, 0.8);
  border: 2px solid rgba(0, 0, 0, 1);
  border-radius: 50%;
  width: 3rem;
  height: 3rem;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background: rgba(255, 255, 255, 0.9);
    border-color: rgba(0, 0, 0);
  }

  &:disabled {
    cursor: not-allowed;
  }
}


.nav-icon {
  color: rgba(0, 0, 0, 0.8);
  font-size: 1.5rem;
}
.carousel-control-prev{
  left: 20px;
}
.carousel-control-next{
  right: 20px;
}


@media screen and (max-width: 600px) {

  .thumbnail-gallery {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 5px;

    .thumbnails {
      overflow-x: auto;
      scroll-behavior: smooth;
      white-space: nowrap;
      width: 100%;
      position: relative;

      .thumbnail-container {
        display: inline-flex; /* Cambiar a inline-flex para soporte en desplazamiento */
      }

      .thumbnail {
        margin: 0 5px;
        cursor: pointer;

        img {
          width: 80px;
          height: 80px;
          object-fit: cover;
        }
      }
    }
  }
  .nav-button {
    position: absolute;
    top: 65%;
    width: 2.5rem;
    height: 2.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: background-color 0.2s;

  }
  .carousel-control-prev{
    left: 20px;
  }
  .carousel-control-next{
    right: 20px;
  }
}
</style>
